import React from 'react';
import PropTypes from 'prop-types';

import { Navigate } from 'react-router-dom';

// Private Route for authenticated users
export const PrivateRoute = (props) => {
    let isLoggedIn = props.isLoggedIn
    
    //localStorage.setItem('lastPath', rest.location.pathname);


    return (
        ( isLoggedIn )
            ? props.children
            : ( <Navigate to="/auth/" /> )
    )
}
